import React from 'react';
import { Helmet } from 'react-helmet-async';
import Jumbotron from '../components/Jumbotron';
import InfoSection from '../components/InfoSection';

const News = () => {
  return (
    <>
      <Helmet>
        <title>NGF - National Gauntlet Federation | Home</title>
        <meta
          name="description"
          content="Welcome to the National Gauntlet Federation. A new era of competitive grappling - High Energy, Fast Pace, Submission Focused, Team Driven. Tournament starts Spring 2027."
        />
        <meta
          name="keywords"
          content="NGF, National Gauntlet Federation, grappling, competitive grappling, submission grappling, BJJ, wrestling, martial arts, combat sports, tournament"
        />
        <meta property="og:title" content="NGF - National Gauntlet Federation" />
        <meta
          property="og:description"
          content="A new era of competitive grappling. High Energy. Fast Pace. Submission Focused. Team Driven."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ngfederation.com/" />
      </Helmet>
      
      <Jumbotron />
      <InfoSection />
    </>
  );
};

export default News;